import React from 'react';
import { Navigate } from 'react-router-dom';

function canAccessAdmin() {
  try {
    const stored = JSON.parse(localStorage.getItem('user'));
    return stored?.role === 'admin' || stored?.role === 'manager';
  } catch {
    return false;
  }
}

export default function PrivateRoute({ children, requireAdmin = false }) {
  const token = localStorage.getItem('token');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !canAccessAdmin()) {
    return <Navigate to="/" replace />;
  }

  return children;
}
